var _LocalStorageManager_KEY_TIMESTAMP, _LocalStorageManager_KEY_ENABLE_BOT, _LocalStorageManager_KEY_ENABLE_CHECKER_BAR, _LocalStorageManager_KEY_ENABLE_CHECKER_RIGHT_ALIGN, _LocalStorageManager_KEY_ENABLE_DATASAVE, _LocalStorageManager_KEY_FAVORITE_STREAMS, _LocalStorageManager_KEY_BOOKMARKS, _LocalStorageManager_KEY_CHAT_VIEW_OFFSET, _LocalStorageManager_KEY_VOLUME, _LocalStorageManager_KEY_THEME_DARK_MODE, _LocalStorageManager_KEY_MUTE_BOT_SETTINGS;
import { __classPrivateFieldGet } from "tslib";
const TRUE = '1';
const FALSE = '0';
const DEFAULT_CHAT_VIEW_OFFSET = 300;
const DEFAULT_VOLUME = 50;
export class LocalStorageManager {
    constructor() {
        _LocalStorageManager_KEY_TIMESTAMP.set(this, 'vega.timestamp');
        _LocalStorageManager_KEY_ENABLE_BOT.set(this, 'vega.enable_bot');
        _LocalStorageManager_KEY_ENABLE_CHECKER_BAR.set(this, 'vega.enable_checker_bar');
        _LocalStorageManager_KEY_ENABLE_CHECKER_RIGHT_ALIGN.set(this, 'vega.enable_checker_right_align');
        _LocalStorageManager_KEY_ENABLE_DATASAVE.set(this, 'vega.enable_datasave');
        _LocalStorageManager_KEY_FAVORITE_STREAMS.set(this, 'vega.favorite_stream');
        _LocalStorageManager_KEY_BOOKMARKS.set(this, 'vega.bookmarks');
        _LocalStorageManager_KEY_CHAT_VIEW_OFFSET.set(this, 'vega.chat_view_offset');
        _LocalStorageManager_KEY_VOLUME.set(this, 'vega.volume');
        _LocalStorageManager_KEY_THEME_DARK_MODE.set(this, 'vega.theme_dark_mode');
        _LocalStorageManager_KEY_MUTE_BOT_SETTINGS.set(this, 'vega.mute_bot_settings');
    }
    get timestamp() {
        return localStorage.getItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_TIMESTAMP, "f")) === TRUE;
    }
    set timestamp(value) {
        localStorage.setItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_TIMESTAMP, "f"), value ? TRUE : FALSE);
    }
    get enableBot() {
        return localStorage.getItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_ENABLE_BOT, "f")) !== FALSE;
    }
    set enableBot(value) {
        localStorage.setItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_ENABLE_BOT, "f"), value ? TRUE : FALSE);
    }
    get enableCheckerBar() {
        return localStorage.getItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_ENABLE_CHECKER_BAR, "f")) !== FALSE;
    }
    set enableCheckerBar(value) {
        localStorage.setItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_ENABLE_CHECKER_BAR, "f"), value ? TRUE : FALSE);
    }
    get enableCheckerRightAlign() {
        return localStorage.getItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_ENABLE_CHECKER_RIGHT_ALIGN, "f")) === TRUE;
    }
    set enableCheckerRightAlign(value) {
        localStorage.setItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_ENABLE_CHECKER_RIGHT_ALIGN, "f"), value ? TRUE : FALSE);
    }
    get enableDataSave() {
        return localStorage.getItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_ENABLE_DATASAVE, "f")) === TRUE;
    }
    set enableDataSave(value) {
        localStorage.setItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_ENABLE_DATASAVE, "f"), value ? TRUE : FALSE);
    }
    get favoriteStreams() {
        return localStorage.getItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_FAVORITE_STREAMS, "f")) || '[]';
    }
    set favoriteStreams(value) {
        localStorage.setItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_FAVORITE_STREAMS, "f"), value ? value : '[]');
    }
    get bookmarks() {
        return localStorage.getItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_BOOKMARKS, "f")) || '[]';
    }
    set bookmarks(value) {
        localStorage.setItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_BOOKMARKS, "f"), value ? value : '[]');
    }
    get chatViewOffset() {
        const raw = localStorage.getItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_CHAT_VIEW_OFFSET, "f"));
        return raw ? parseInt(raw) : DEFAULT_CHAT_VIEW_OFFSET;
    }
    set chatViewOffset(value) {
        localStorage.setItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_CHAT_VIEW_OFFSET, "f"), value.toString());
    }
    get volume() {
        const raw = localStorage.getItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_VOLUME, "f"));
        return raw ? parseInt(raw) : DEFAULT_VOLUME;
    }
    set volume(value) {
        localStorage.setItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_VOLUME, "f"), value.toString());
    }
    get isDarkMode() {
        return localStorage.getItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_THEME_DARK_MODE, "f")) !== FALSE;
    }
    set isDarkMode(value) {
        localStorage.setItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_THEME_DARK_MODE, "f"), value ? TRUE : FALSE);
    }
    get muteBotSettings() {
        return localStorage.getItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_MUTE_BOT_SETTINGS, "f")) || '[]';
    }
    set muteBotSettings(value) {
        localStorage.setItem(__classPrivateFieldGet(this, _LocalStorageManager_KEY_MUTE_BOT_SETTINGS, "f"), value ? value : '[]');
    }
}
_LocalStorageManager_KEY_TIMESTAMP = new WeakMap(), _LocalStorageManager_KEY_ENABLE_BOT = new WeakMap(), _LocalStorageManager_KEY_ENABLE_CHECKER_BAR = new WeakMap(), _LocalStorageManager_KEY_ENABLE_CHECKER_RIGHT_ALIGN = new WeakMap(), _LocalStorageManager_KEY_ENABLE_DATASAVE = new WeakMap(), _LocalStorageManager_KEY_FAVORITE_STREAMS = new WeakMap(), _LocalStorageManager_KEY_BOOKMARKS = new WeakMap(), _LocalStorageManager_KEY_CHAT_VIEW_OFFSET = new WeakMap(), _LocalStorageManager_KEY_VOLUME = new WeakMap(), _LocalStorageManager_KEY_THEME_DARK_MODE = new WeakMap(), _LocalStorageManager_KEY_MUTE_BOT_SETTINGS = new WeakMap();
